/**
 * De dónde sale el tenant FUERA de React, para los `loader` (ADR-0012, paso 2).
 *
 * 🪤 Acá estuvo el bloqueo real de este paso. `resolveTenantId()` resuelve por SUBDOMINIO y sirve
 * para las tiendas; en el panel (`web.smarty.lat`) devuelve `null` porque el dominio es reservado.
 * El tenant del panel vive en el contexto de autenticación… al que un `loader` no tiene acceso,
 * porque corre antes de React.
 *
 * `AuthProvider` ya publica `cached_tenant_id` en `localStorage` al resolver la sesión, así que es
 * legible sincrónicamente desde el router. No se duplica lógica de auth: se lee lo que auth ya dejó.
 *
 * 🪤 Es un CACHÉ y puede estar desactualizado un instante al cambiar de tenant. El daño posible está
 * acotado a UNA consulta desperdiciada: la pantalla usa el tenant real del contexto, o sea otra
 * clave, así que jamás se muestra el dato del tenant equivocado — sólo se calienta una entrada que
 * nadie va a leer.
 */
export function tenantDelPanel(): string | null {
  try {
    return localStorage.getItem('cached_tenant_id');
  } catch {
    return null; // modo incógnito con storage bloqueado: la pantalla se encarga
  }
}
